import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

const DiscountBanner = ({ size = 'large' }) => {
  if (size === 'large') {
    return (
      <div className="discount-banner-large">
        <div className="container">
          <div className="discount-banner-content">
            <Sparkles className="discount-icon" />
            <span className="discount-text">
              <strong>Special Offer:</strong> Get 10% off your first booking! Use code{' '}
              <span className="discount-code">WALSALL10</span>
            </span>
            <Link to="/contact" className="discount-cta">
              Book Now
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="discount-banner-small">
      <div className="container">
        <div className="discount-banner-small-content">
          <Sparkles className="discount-icon-small" />
          <span className="discount-text-small">
            New customers: Save 10% with code <strong>WALSALL10</strong>
          </span>
        </div>
      </div>
    </div>
  );
};

export default DiscountBanner;
